function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "12"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#008AF5",
  d: "M8.56 8.914c0-.3.24-.514.52-.514s.52.214.52.514v.943c0 1.157-.92 2.143-2 2.143H2c-1.12 0-2-.986-2-2.143v-.943c0-.3.24-.514.52-.514s.48.214.48.514v.943c0 .557.44 1.029 1 1.029h5.6c.52 0 .96-.472.96-1.029v-.943zM1.353 6.281a.548.548 0 010-.76c.204-.21.53-.21.734 0L4.29 7.799V.548A.55.55 0 014.82 0c.286 0 .49.253.49.548v7.25l2.203-2.276c.204-.21.53-.21.734 0a.547.547 0 010 .759l-3.06 3.16a.503.503 0 01-.734 0l-3.1-3.16z"
})));